import { match } from 'ts-pattern';
import { User, UserType } from '../models/user.model';

/**
 * Determines the type of user based on their access levels.
 * @param user - The user object to evaluate.
 * @returns The type of the user.
 */
export const getUserType = (user: User): UserType => {
  return match(user)
    .when(
      ({ operatorAccessLevel }) => operatorAccessLevel !== 'none',
      () => 'operator',
    )
    .when(
      ({ buyerAccessLevel }) => buyerAccessLevel !== 'none',
      () => 'buyer',
    )
    .when(
      ({ supplierAccessLevel }) => supplierAccessLevel !== 'none',
      () => 'supplier',
    )
    .otherwise(() => 'none') as UserType;
};
